/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon16Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g
        stroke={"#292929"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
        clipPath={"url(#a)"}
      >
        <path
          d={
            "M7.5 11.875h5m-5-2.5h5m0-6.25h3.125a.625.625 0 0 1 .625.625v13.125a.624.624 0 0 1-.625.625H4.375a.625.625 0 0 1-.625-.625V3.75a.625.625 0 0 1 .625-.625H7.5"
          }
        ></path>

        <path d={"M6.875 5.625V5a3.125 3.125 0 0 1 6.25 0v.625z"}></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon16Icon;
/* prettier-ignore-end */
